import { useState, useEffect, useMemo } from "react";
import BinImage from "../assets/Delete.png";
import WarnImage from "../assets/Warn.png";
import IgnoreImage from "../assets/Ignore.png";
import BackgroundImage from "../assets/moderation-background.png";
import {
  Layout,
  Typography,
  Button,
  Tooltip,
  Row,
  Col,
  Collapse,
  Card,
} from "antd";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { useMobxStores } from "../stores/stores";
import LinkOut from "../assets/link-out.png";
import "./Moderation.css";
// import { ReactComponent as TopLeftShape } from "../assets/Ellipse38.svg";
import { ReactComponent as TopRightShape } from "../assets/Ellipse56.svg";
// import { ReactComponent as BigBlueShape } from "../assets/Ellipse57.svg";
import { ReactComponent as BigBlueShape } from "../assets/MarketPlaceTopRightLeft.svg";
import { ReactComponent as TopRightShapeBlur } from "../assets/Ellipse56Blur.svg";
// import { ReactComponent as BigBlueShape } from "../assets/Ellipse57.svg";
import { ReactComponent as BigBlueShapeBlur } from "../assets/MarketPlaceTopRightLeftBlur.svg";
// import { ReactComponent as BottomRightShape } from "../assets/Group42.svg";

const { Title, Text, Link: AntLink } = Typography;
const { Panel } = Collapse;
const { Content } = Layout;

const Moderation = () => {
  const { reportStore, marketplaceStore } = useMobxStores();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchItems() {
      await marketplaceStore.GetMarketplaceItems();
    }
    fetchItems();
  }, [marketplaceStore]);

  useEffect(() => {
    async function fetchReports() {
      await reportStore.GetReports();
    }
    fetchReports();
  }, [reportStore]);

  const reports = useMemo(
    () =>
      Object.values(
        reportStore.reports?.reduce((acc, cur) => {
          if (!acc[cur.item]) {
            acc[cur.item] = {
              itemId: cur.item,
              itemName: cur.item_name,
              reportData: [],
            };
          }

          acc[cur.item].reportData.push(cur);

          return acc;
        }, {})
      ),
    [reportStore.reports]
  );

  const handleAction = async (userAction, itemIndex) => {
    await Promise.all(
      reports[itemIndex].reportData.map((data, index) => {
        let action = userAction;
        if (index > 0 && userAction === "warned") {
          action = "ignored";
        }
        if (index > 0 && userAction === "removed") {
          action = "removed";
        }
        return reportStore.UpdateReportById(data.id, { action });
      })
    );
  };

  const renderActions = (itemIndex, reportIndex, status) => (
    <>
      {status !== "warned" && status !== "removed" && (
        <>
          <Tooltip title="Warn">
            <Button
              shape="circle"
              onClick={() => handleAction("warned", itemIndex)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: 0,
                width: "auto",
                height: "auto",
              }}
              icon={
                <img
                  src={WarnImage}
                  alt="Warn"
                  style={{
                    width: "28px",
                    height: "28px",
                    display: "block",
                  }}
                />
              }
            />
          </Tooltip>
          <Tooltip title="Ignore">
            <Button
              shape="circle"
              onClick={() => handleAction("ignored", itemIndex)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: 0,
                marginLeft: "1em",
                width: "auto",
                height: "auto",
              }}
              icon={
                <img
                  src={IgnoreImage}
                  alt="Ignore"
                  style={{
                    width: "28px",
                    height: "28px",
                    display: "block",
                  }}
                />
              }
            />
          </Tooltip>
        </>
      )}
      {status === "warned" && (
        <>
          <Tooltip title="Remove">
            <Button
              shape="circle"
              onClick={() => handleAction("removed", itemIndex)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: 0,
                width: "auto",
                height: "auto",
              }}
              icon={
                <img
                  src={BinImage}
                  alt="Remove"
                  style={{
                    width: "28px",
                    height: "28px",
                    display: "block",
                  }}
                />
              }
            />
          </Tooltip>
          <Tooltip title="Ignore">
            <Button
              shape="circle"
              onClick={() => handleAction("ignored", itemIndex)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: 0,
                marginLeft: "1em",
                width: "auto",
                height: "auto",
              }}
              icon={
                <img
                  src={IgnoreImage}
                  alt="Ignore"
                  style={{
                    width: "28px",
                    height: "28px",
                    display: "block",
                  }}
                />
              }
            />
          </Tooltip>
        </>
      )}
    </>
  );

  const statusStyle = {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    border: 0,
    fontSize: "18px",
    fontWeight: 500,
    background: "linear-gradient(91.54deg, #D01FDF 7.3%, #755FD8 45.53%)",
    webkitBackgroundClip: "text",
    webkitTextFillColor: "transparent",
    backgroundClip: "text",
    textFillColor: "transparent",
  };

  const [activeKey, setActiveKey] = useState(null);

  const handleChange = (key) => {
    setActiveKey(key);
  };

  const getPanelStyle = (key) => {
    return activeKey === key
      ? {
          background: "rgba(0,0,0,0)",
          border: "none",
          borderTop: "2px solid",
          borderImage: "linear-gradient(90deg, #D01FDF 0%, #2A93D3 100%) 1",
        }
      : {
          background: "rgba(0,0,0,0)",
          border: "none",
          borderBottom: "2px solid",
          borderImage: "linear-gradient(90deg, #D01FDF 0%, #2A93D3 100%) 1",
        };
  };

  const headerStyle = {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "32px",
    textAlign: "right",
    color: "#FFFFFF",
    lineHeight: 1,
  };

  return (
    <div style={{ minHeight: "100vh", position: "relative" }}>
      {/* Background (fixed, behind everything) */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "#1E202F",
          zIndex: -1,
        }}
      >
        <TopRightShape
          style={{
            position: "fixed",
            top: "0vh",
            right: "10vw",
            width: "6vw",
            pointerEvents: "none",
          }}
        />
        <TopRightShape
          style={{
            position: "fixed",
            bottom: "-6vh",
            right: "6vw",
            width: "4vw",
            pointerEvents: "none",
          }}
        />
        <BigBlueShape
          style={{
            position: "fixed",
            bottom: "0vh",
            right: "6vw",
            width: "8vw",
            pointerEvents: "none",
          }}
        />
        <BigBlueShape
          style={{
            position: "fixed",
            top: "36vh",
            right: "14vw",
            width: "8vw",
            pointerEvents: "none",
          }}
        />
        <TopRightShapeBlur
          style={{
            position: "fixed",
            top: "50vh",
            right: "25vw",
            width: "4vw",
            pointerEvents: "none",
          }}
        />
        <BigBlueShapeBlur
          style={{
            position: "fixed",
            top: "68vh",
            right: "35vw",
            width: "4vw",
            pointerEvents: "none",
          }}
        />
        <BigBlueShape
          style={{
            position: "fixed",
            top: "14vh",
            left: "4vw",
            width: "12vw",
            pointerEvents: "none",
          }}
        />
        <TopRightShape
          style={{
            position: "fixed",
            top: "-2vh",
            left: "3vw",
            width: "8vw",
            pointerEvents: "none",
          }}
        />
        <TopRightShape
          style={{
            position: "fixed",
            bottom: "2vh",
            left: "4vw",
            width: "5vw",
            pointerEvents: "none",
          }}
        />
      </div>

      {/* Foreground content (normal flow) */}
      <div style={{ position: "relative", zIndex: 1, paddingTop: "2vh" }}>
        <Content
          // style={{
          //   paddingLeft: "300px",
          //   paddingRight: "300px",
          //   paddingTop: "24px",
          //   paddingBottom: "24px",
          // }}

          style={{
            paddingTop: "24px",
            paddingBottom: "24px",

            width: "80vw",
            minWidth: "900px",
            margin: "0 auto", // centers horizontally
          }}
        >
          <Title
            style={{
              fontFamily: "Work Sans",
              fontStyle: "normal",
              fontWeight: 500,
              color: " #FFFFFF",
              fontSize: "50px",
              textAlign: "start",
              marginBottom: "52px",
            }}
          >
            Moderation System
          </Title>
          <Card className="moderation-card">
            <Title
              level={2}
              style={{
                color: "rgb(255,255,255)",
                backgroundColor: "#D01FDF",
                padding: "8px",
                borderRadius: "10px",
                margin: "-1px",
                paddingLeft: "15px",
                fontWeight: "400",
              }}
            >
              Reported Items
            </Title>
            <Collapse
              accordion
              onChange={handleChange}
              style={{ border: "none", marginBottom: "10em" }}
            >
              {reports?.map((reportItem, itemIndex) => (
                <Panel
                  header={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "end",
                        gap: "22px",
                      }}
                    >
                      <span style={headerStyle}>{reportItem.itemName}</span>
                      <button
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          paddingBottom: "2px",
                          backgroundColor: "transparent",
                          border: "none",
                          outline: "none",
                          width: "fit-content",
                          height: "fit-content",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/marketplace/${reportItem.itemId}`);
                        }}
                      >
                        <img
                          src={LinkOut}
                          style={{ width: "24px", height: "24px" }}
                          alt="link out"
                        />
                      </button>
                    </div>
                  }
                  key={reportItem.itemId}
                  style={getPanelStyle(reportItem.itemId)}
                  showArrow={false}
                >
                  <Row
                    gutter={16}
                    style={{
                      marginTop: "-2em",
                    }}
                  >
                    <Col span={4}>
                      <Title level={2} style={{ color: "white" }}>
                        Reason
                      </Title>
                    </Col>
                    <Col span={6}>
                      <Title level={2} style={{ color: "white" }}>
                        Reporter
                      </Title>
                    </Col>
                    <Col span={4}>
                      <Title level={2} style={{ color: "white" }}>
                        Received
                      </Title>
                    </Col>
                    <Col span={4}>
                      <Title level={2} style={{ color: "white" }}>
                        Status
                      </Title>
                    </Col>
                    <Col span={5}>
                      <Title level={2} style={{ color: "white" }}>
                        Action
                      </Title>
                    </Col>
                  </Row>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {reportItem.reportData?.map((report, reportIndex) => (
                      <Row gutter={16} key={`${report.key}-${reportIndex}`}>
                        <Col
                          span={4}
                          style={{
                            display: "flex",
                            alignItems: "end",
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: "Work Sans",
                              fontStyle: "normal",
                              fontWeight: 300,
                              fontSize: "18px",
                              color: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            {report.reason}
                          </Text>
                        </Col>
                        <Col
                          span={6}
                          style={{
                            display: "flex",
                            alignItems: "end",
                          }}
                        >
                          <AntLink
                            style={{
                              fontFamily: "Work Sans",
                              fontStyle: "normal",
                              fontWeight: 400,
                              fontSize: "18px",
                              textDecorationLine: "underline",
                              color: "#D01FDF",
                            }}
                            onClick={() =>
                              navigate(`/portfolio/${report.reporter_username}`)
                            }
                          >
                            {report.reporter_username}
                          </AntLink>
                        </Col>
                        <Col
                          span={4}
                          style={{
                            display: "flex",
                            alignItems: "end",
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: "Work Sans",
                              fontStyle: "normal",
                              fontWeight: 300,
                              fontSize: "18px",
                              color: "rgba(255, 255, 255, 0.8)",
                            }}
                          >
                            {new Date(report.report_received).toLocaleString()}
                          </Text>
                        </Col>
                        <Col
                          span={4}
                          style={{
                            display: "flex",
                            alignItems: "end",
                          }}
                        >
                          {reportIndex === 0 && (
                            <Text color="default" style={statusStyle}>
                              {report.action ?? "Action pending"}
                            </Text>
                          )}
                        </Col>
                        <Col
                          span={5}
                          style={{
                            display: "flex",
                            alignItems: "end",
                          }}
                        >
                          {reportIndex === 0 &&
                            renderActions(
                              itemIndex,
                              reportIndex,
                              report.action
                            )}
                        </Col>
                      </Row>
                    ))}
                  </div>
                </Panel>
              ))}
            </Collapse>
          </Card>
        </Content>
      </div>
    </div>
  );
};

export default observer(Moderation);
